<!-- Parametros PopupConfirmação(todos opcionais): cor_imagem, titulo,
  texto, texto_botao1, cor_botao1, cor_background_botao1, hover_botao1,
  texto_botao2, cor_botao2, cor_background_botao2, hover_botao2, confirma_acao, id_modal-->

<!-- <b-button v-b-modal.idModal>
 <PopupConfirmacao
      cor_imagem="#E2574C"
      titulo="Atenção"
      texto="As alterações não serão salvas, deseja continuar?"
      texto_botao1="Continuar"
      cor_botao1="#FFFFFF"
      cor_background_botao1="#EB5353"
      hover_botao1="#a53a36"
      texto_botao2="Cancelar"
      cor_botao2="#FFFFFF"
      cor_background_botao2="#ADADAD"
      hover_botao2="#8b8b8b"
      :confirma_acao=função de confirmar a acao
      id_modal="idModal"
    />
    </b-button>-->
<template>
  <div id="containerModalPopup">
    <b-modal centered size="md" :id="id_modal" hide-header hide-footer>
      <div id="principal">
        <div>
          <svg width="70" height="70" id="imagem" class="mt-2">
            <path
              d="M35 0C15.6712 0 0 15.6712 0 35C0 54.331 15.6712 70 35 70C54.331 70 70 54.3332 70 35C70 15.6712 54.3308 0 35 0ZM35 63.4374C19.2938 63.4374 6.56261 50.7062 6.56261 35C6.56261 19.2938 19.2938 6.56261 35 6.56261C50.7062 6.56261 63.4374 19.2938 63.4374 35C63.4374 50.7062 50.7062 63.4374 35 63.4374ZM35.0022 15.3496C32.4954 15.3496 30.5987 16.6578 30.5987 18.7709V38.1521C30.5987 40.2674 32.4952 41.5712 35.0022 41.5712C37.4478 41.5712 39.4057 40.2128 39.4057 38.1521V18.7709C39.4055 16.708 37.4478 15.3496 35.0022 15.3496ZM35.0022 45.9375C32.5938 45.9375 30.6337 47.8976 30.6337 50.308C30.6337 52.7142 32.5938 54.6744 35.0022 54.6744C37.4106 54.6744 39.3685 52.7142 39.3685 50.308C39.3683 47.8974 37.4106 45.9375 35.0022 45.9375Z"
              v-bind:fill="cor_imagem"
            />
          </svg>
        </div>
        <div id="titulo" class="mt-2">{{ titulo }}</div>
        <div id="texto" class="mt-2">{{ texto }}</div>
        <div id="flexcaixa" class="mt-3">
          <b-button
            id="botao1"
            class="mr-2"
            v-bind:style="{
              color: cor_botao1,
              'background-color': cor_background_botao1,
            }"
            @mouseover="mouse1Over"
            @click="confirma_acao"
            @mouseleave="mouse1Leave"
            >{{ texto_botao1 }}</b-button
          >
          <b-button
            @click="hideModal(id_modal)"
            id="botao2"
            class="ml-2"
            v-bind:style="{
              color: cor_botao2,
              'background-color': cor_background_botao2,
            }"
            @mouseover="mouse2Over"
            @mouseleave="mouse2Leave"
            >{{ texto_botao2 }}</b-button
          >
        </div>
        <div class="pb-3"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "PopupConfirmacao",
  props: {
    id_modal: {
      type: String,
      required: true,
    },
    confirma_acao: {
      type: Function,
      required: false,
    },
    cor_imagem: {
      type: String,
      required: false,
    },
    titulo: {
      type: String,
      required: false,
    },
    texto: {
      type: String,
      required: false,
    },
    texto_botao1: {
      type: String,
      required: false,
    },
    cor_botao1: {
      type: String,
      required: false,
    },
    cor_background_botao1: {
      type: String,
      required: false,
    },
    hover_botao1: {
      type: String,
      required: false,
    },
    texto_botao2: {
      type: String,
      required: false,
    },
    cor_botao2: {
      type: String,
      required: false,
    },
    cor_background_botao2: {
      type: String,
      required: false,
    },
    hover_botao2: {
      type: String,
      required: false,
    },
  },
  methods: {
    mouse1Over: function() {
      document.getElementById(
        "botao1"
      ).style.backgroundColor = this.hover_botao1;
    },
    mouse1Leave: function() {
      document.getElementById(
        "botao1"
      ).style.backgroundColor = this.cor_background_botao1;
    },
    mouse2Over: function() {
      document.getElementById(
        "botao2"
      ).style.backgroundColor = this.hover_botao2;
    },
    mouse2Leave: function() {
      document.getElementById(
        "botao2"
      ).style.backgroundColor = this.cor_background_botao2;
    },
    hideModal(id) {
      this.$root.$emit("bv::hide::modal", id, "#btnShow");
    },
  },
};
</script>

<style scoped lang="scss">
#containerModalPopup {
  z-index: 800;
}
#principal {
  text-align: center;
}
#titulo {
  color: #000000;
  font-size: 1.5em;
  font-weight: 1000;
  text-align: center;
}

#flexcaixa {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
@media (min-width: 320px) and (max-width: 375px) {
  #texto {
    width: 21rem;
  }
}
@media (max-width: 375px) {
  #principal {
    width: 18rem;
  }
  #texto {
    width: 18rem;
  }
}
@media (max-width: 280px) {
  #principal {
    width: 15rem;
  }
  #texto {
    width: 15rem;
  }
}
</style>
